import { Injectable } from "@angular/core";
import { WriteableNote } from "../interfaces/writeable-note.interface";

@Injectable({
	providedIn: 'root',
})
export class LocalStorageHelper {
	public setCreatedAccountId(accountId: string) {
		localStorage.setItem("createdAccountId", accountId);
	}

	public getCreatedAccountId(): string {
		return localStorage.getItem("createdAccountId");
	}

	public getRememberedCredentials(): string | null {
		return localStorage.getItem('rememberedEmail');
	}

	public saveRememberedCredentials(email: string) {
		localStorage.setItem('rememberedEmail', email);
	}

	public setRecentlyCreatedNoteId(noteId: string) {
		localStorage.setItem("recentlyCreatedNoteId", noteId);
	}
	
	public getRecentlyCreatedNoteId(): string {
		return localStorage.getItem("recentlyCreatedNoteId") || "";
	}

	public deleteRecentlyCreatedNoteId() {
		localStorage.removeItem("recentlyCreatedNoteId");
	}

	public clearRememberedCredentials() {
		localStorage.removeItem('rememberedEmail');
	}

	public setUserOwnedDiaryId(diaryId: string) {
		localStorage.setItem("userOwnedDiaryId", diaryId);
	}

	public getUserOwnedDiaryId(): string {
		return localStorage.getItem("userOwnedDiaryId");
	}

	public setComponentOrder(componentOrder: string) {
		localStorage.setItem("componentOrder", componentOrder);
	}

	public getComponentOrder(): string {
		return localStorage.getItem("componentOrder");
	}

	public setScannedAccountId(scannedAccountId) {
		localStorage.setItem("scannedAccountId", scannedAccountId);
	}

	public getScannedAccountId(): string {
		return localStorage.getItem("scannedAccountId");
	}

	public setScannedDiaryId(scannedDiaryId) {
		localStorage.setItem("scannedDiaryId", scannedDiaryId);
	}

	public getScannedDiaryId(): string | null {
		return localStorage.getItem("scannedDiaryId");
	}

	public setScannedTitle(scannedTitle) {
		localStorage.setItem("scannedTitle", scannedTitle);
	}

	public getScannedTitle(): string {
		return localStorage.getItem("scannedTitle");
	}

	public setCurrentAnonUser(anonUser: any) {
		localStorage.setItem('currentAnonUser', JSON.stringify(anonUser));
	}

	public wipeCurrentAnonUser() {
		localStorage.removeItem('currentAnonUser');
	}

	public getCurrentAnonUser(): any {
		return JSON.parse(localStorage.getItem('currentAnonUser'));
	}

	public getCurrentAuthenticatedUser(): any {
		return JSON.parse(localStorage.getItem("currentAuthenticatedUser"));
	}

	public setCurrentNoteFlowData(notes: WriteableNote[]) {
		localStorage.setItem('currentNoteFlowData', JSON.stringify(notes));
	}

	public getCurrentNoteFlowData(): WriteableNote[] {
		return JSON.parse(localStorage.getItem('currentNoteFlowData')) as WriteableNote[] || [];
	}

	public removeCurrentNoteFlowData() {
		localStorage.removeItem('currentNoteFlowData');
	}

	public setCurrentDiaryForCurrentNote(diaryId: string) {
		localStorage.setItem("currentDiaryForCurrentNote", diaryId);
	}

	public getCurrentDiaryForCurrentNote(): string {
		return localStorage.getItem("currentDiaryForCurrentNote");
	}

	public removeCurrentDiaryForCurrentNote() {
		localStorage.removeItem("currentDiaryForCurrentNote");
	}

	public setFirstName(firstName: string) {
		localStorage.setItem('firstName', firstName);
	}

	public getFirstName(): string {
		return localStorage.getItem('firstName');
	}

	public setPin(pin: string) {
		localStorage.setItem('pin', pin);
	}

	public getPin(): string {
		return localStorage.getItem('pin');
	}

	public setFullyQualifiedShortenedUrlLink(url: string) {
		localStorage.setItem('fullyQualifiedShortenedUrlLink', url);
	}

	public getFullyQualifiedShortenedUrlLink(): string {
		return localStorage.getItem('fullyQualifiedShortenedUrlLink');
	}

	public setAccountId(accountId: string) {
		localStorage.setItem('accountId', accountId);
	}

	public getAccountId(): string {
		return localStorage.getItem('accountId') || "";
	}
}
